import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimePickerComponent } from './timepicker.component';
import { TimePickerModule } from './timepicker.module';
/**
 * NgModule definition for the TimePicker component with providers.
 */
export class TimePickerAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, TimePickerModule],
    exports: [
        TimePickerModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TimePickerAllModule_tsickle_Closure_declarations() {
/** @type {?} */
TimePickerAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TimePickerAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
